module.exports = __webpack_public_path__ + "static/media/u2-min.6d9484ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/u2-min.svg
// module id = 244
// module chunks = 0